<template>
  <div>
    <el-form :inline="true" :model="form" @submit.native.prevent>
      <div style="display: flex; flex-wrap: wrap">
        <el-form-item label="试题分类">
          <classify
            :value.sync="flbhList"
            type="questions"
            :multiple="true"
            style="width: 180px"
          ></classify>
        </el-form-item>
        <!-- &nbsp;
        <el-button type="success" @click="showDialog = true">选择试题分类</el-button>
        <el-dialog title="选择试题分类" :visible.sync="showDialog" :append-to-body="true" width="30%" center>
          <classifyTree :value.sync="flbhList" type="questions" :visible.sync="showDialog"></classifyTree>
        </el-dialog> -->
        <el-form-item label="难易程度">
          <el-select v-model="form.nycd" style="width: 100px">
            <el-option label="全部" value=""></el-option>
            <el-option label="简单" value="1"></el-option>
            <el-option label="普通" value="2"></el-option>
            <el-option label="困难" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人">
          <el-input
            v-model="form.yhmc"
            style="width: 120px"
            placeholder="输入创建人"
            @keyup.enter.native="query()"
          ></el-input>
        </el-form-item>
        <el-form-item label="试题内容">
          <el-input
            v-model="form.stmc"
            style="width: 180px"
            placeholder="输入试题内容搜索"
            @keyup.enter.native="query()"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="form.cjrqRange"
            style="width: 210px"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <!-- <el-form-item label="试题标签">
          <span>1，2，3，4&emsp;</span>
        </el-form-item> -->
        <el-form-item label="">
          <el-checkbox
            v-model="form.jxzct"
            true-label="1"
            false-label="0"
            size="medium"
            >仅查询易错题</el-checkbox
          >
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 1rem" type="primary" @click="query()"
            >查询</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <el-table
      ref="dataTable"
      :data="tableData"
      type="selection"
      style="width: 100%"
      :border="true"
      height="480px"
      :row-class-name="tableRowClassName"
      @select="handelSelect"
      @select-all="handleSelectionAll"
    >
      <el-table-column
        type="selection"
        width="50"
        prop="stid"
        :selectable="selectable"
      ></el-table-column>
      <el-table-column label="题型" width="80" prop="txmc"></el-table-column>
      <el-table-column label="试题分类" width="120" prop="flmc" />
      <el-table-column label="试题内容" width="250">
        <template slot-scope="scope">
          <el-col
            style="
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            :span="22"
            v-html="scope.row.tg || '&nbsp;'"
          ></el-col>
          <el-col :span="2">
            <el-popover trigger="hover" placement="top">
              <div
                style="max-width: 1000px"
                v-if="scope.row.stnr"
                class="editorHtml"
                v-html="scope.row.stnr"
              ></div>
              <pre style="max-width: 1000px" v-else v-html="scope.row.tg"></pre>
              <div
                style="max-width: 1000px"
                v-if="
                  scope.row.tx === '1' ||
                  scope.row.tx === '2' ||
                  scope.row.tx === '4'
                "
              >
                <div
                  v-for="(xxObj, index) in scope.row.ksyStkStxxList"
                  :key="index"
                  v-html="`${options[index]}. ${xxObj.xxsm}`"
                ></div>
              </div>
              <i slot="reference" class="el-icon-more"></i>
            </el-popover>
          </el-col>
        </template>
      </el-table-column>
      <el-table-column label="难度" width="60" prop="ndmc" />
      <el-table-column label="创建人" width="80" prop="yhmc" />
      <el-table-column label="创建时间" width="150" prop="cjsj" />
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
</template>
<script>
import classify from '@/components/select/classify'
// import classifyTree from '@/components/tree/classifyTree'
import * as questions from '@/api/questions'
import constant from '@/assets/js/constant.js'

export default {
  data () {
    return {
      pickerOptions: constant.pickerOptions,
      options: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],

      showDialog: false,
      flbhList: [],
      form: {
        nycd: null,
        jxzct: null,
        stmc: null,
        cjrqRange: null, // 创建日期范围
        yhmc: null // 创建人
      },
      typeOfQuestionItem: [],
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: []
    }
  },
  props: {
    dtObj: Object,
    allDtData: Array
  },
  components: {
    classify
    // classifyTree
  },
  watch: {
    'dtObj.dtid': {
      handler (val, oldVal) {
        this.query()
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    selectable (row, index) {
      let flag = true
      this.allDtData.map(dt => {
        if (dt.ksySjkStList.find(st => st.stid === row.stid)) {
          flag = false
        }
      })
      if (this.dtObj.ksySjkStList.find(st => st.stid === row.stid)) {
        flag = true
      }
      return flag
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign(
        {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          ksrq: this.form.cjrqRange ? this.form.cjrqRange[0] : null,
          jsrq: this.form.cjrqRange ? this.form.cjrqRange[1] : null
        },
        this.form
      )
      delete params.cjrqRange
      params.stfls = this.flbhList ? this.flbhList.join(',') : ''
      params.tx = this.dtObj.tx
      questions.getStList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      const st = this.dtObj.ksySjkStList.find(st => st.stid === row.stid)
      if (st) {
        this.$refs.dataTable.toggleRowSelection(row, true)
        return 'success-row'
      } else {
        return ''
      }
    },
    handelSelect (rows, row) {
      if (rows.indexOf(row) !== -1) {
        this.appendToDt(row)
      } else {
        this.removeOfDt(row)
      }
    },
    // 复选框选中状态改变
    handleSelectionAll (rows) {
      // 全选
      if (rows.length > 0) {
        // 添加试题
        this.tableData.forEach(row => {
          if (this.selectable(row)) {
            this.appendToDt(row)
          }
        })
      } else {
        // 反全选
        // 移除试题
        this.tableData.forEach(row => {
          this.removeOfDt(row)
        })
      }
    },
    removeOfDt (row) {
      if (row.tx !== this.dtObj.tx) {
        this.$message.warning('试题题型不一致！')
        return
      }
      this.dtObj.ksySjkStList = this.dtObj.ksySjkStList.filter(
        st => st.stid !== row.stid
      )
      this.$emit('countAll')
    },
    appendToDt (row) {
      if (row.tx !== this.dtObj.tx) {
        this.$message.warning('试题题型不一致！')
        return
      }
      const list = this.dtObj.ksySjkStList
      if (list.map(a => a.stid).indexOf(row.stid) !== -1) {
        // 试题已存在
        return
      }
      let maxXsxh = Math.max(...list.map(st => st.xsxh || 0))
      maxXsxh = maxXsxh === -Infinity ? 0 : maxXsxh
      const ksySjkSt = {
        sjid: this.dtObj.sjid,
        dtid: this.dtObj.dtid,
        stid: row.stid,
        stfz: this.dtObj.mxtfz,
        isMTChanged_: false,
        xsxh: maxXsxh + 1,
        tg: row.tg,
        stnr: row.stnr,
        tx: row.tx,
        nycd: row.nycd,
        flbh: row.flbh,
        stbb: row.stbb,
        xtgs: row.xtgs,
        ksySjkZhtList: row.ksyStkZhtList,
        ksySjkStxxList: row.ksyStkStxxList,
        ksySjkStda: row.ksyStkStda
      }
      // 增加一个'考生答案'虚拟字段
      if (ksySjkSt.ksySjkStda) {
        let ksda = null
        if (ksySjkSt.tx === '2' || ksySjkSt.tx === '3') {
          ksda = ksySjkSt.ksySjkStda.bzda
            ? ksySjkSt.ksySjkStda.bzda.split('€')
            : null
        } else {
          ksda = ksySjkSt.ksySjkStda.bzda
        }
        this.$set(ksySjkSt.ksySjkStda, 'ksda', ksda)
      }
      ksySjkSt.ksySjkZhtList.forEach(ksySjkZht => {
        if (ksySjkZht.ksySjkStda) {
          let ksda = null
          if (ksySjkZht.tx === '2' || ksySjkSt.tx === '3') {
            ksda = ksySjkZht.ksySjkStda.bzda
              ? ksySjkZht.ksySjkStda.bzda.split('€')
              : null
          } else {
            ksda = ksySjkZht.ksySjkStda.bzda
          }
          this.$set(ksySjkZht.ksySjkStda, 'ksda', ksda)
        }
      })
      list.push(ksySjkSt)
      this.$emit('countAll')
    }
  },
  mounted () {
    // 进入页面后进行查询
    this.query()
  }
}
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
